module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_c('router-link', {
    attrs: {
      "to": "/facilities"
    }
  }, [_vm._v("Facilities")]), _vm._v(" "), _c('small', [_vm._v("Facility Record")])], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col-lg-4 connectedSortable ui-sortable"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.facility.name))]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Nivi ID")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.facility._id))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Active")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.facility.active))])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Type")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.facility.type))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Owner")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.facility.owner))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Size")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.facility.size))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Phone Number")]), _vm._v(" "), _c('td', [_c('ul', _vm._l((_vm.facility.phones), function(phone) {
    return _c('li', [_vm._v(_vm._s(phone))])
  }))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Email")]), _vm._v(" "), _c('td', [(_vm.facility.emails) ? _c('ul', _vm._l((_vm.facility.emails), function(email) {
    return _c('li', [_vm._v(_vm._s(email))])
  })) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Methods")]), _vm._v(" "), _c('td', [_c('ul', _vm._l((_vm.facility.methods), function(methods) {
    return _c('li', [_vm._v(_vm._s(methods))])
  }))])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])])])])]), _vm._v(" "), _c('section', {
    staticClass: "col-lg-8 connectedSortable ui-sortable"
  }, [_c('div', {
    staticClass: "box box-solid"
  }, [_vm._m(5), _vm._v(" "), (_vm.no_coordinates_message) ? _c('div', {
    staticClass: "alert alert-warning alert-dismissible"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(6), _vm._v("\n            No Coordniates available for the facility\n          ")]) : _vm._e(), _vm._v(" "), (_vm.coordinates_available) ? _c('div', {
    staticClass: "box-body"
  }, [_c('gmap-map', {
    staticStyle: {
      "width": "auto",
      "height": "500px"
    },
    attrs: {
      "center": _vm.center,
      "zoom": 10
    }
  }, _vm._l((_vm.markers), function(m) {
    return _c('gmap-marker', {
      key: _vm.index,
      attrs: {
        "icon": m.marker,
        "position": m.position,
        "clickable": true
      },
      on: {
        "click": function($event) {
          _vm.center = m.position, m.opened = !m.opened
        }
      }
    }, [_c('gmap-info-window', {
      attrs: {
        "opened": m.opened
      }
    }, [_vm._v(_vm._s(m.text))])], 1)
  }))], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.facility.heirachy.county))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.facility.heirachy.subcounty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.facility.ward))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.markers[0].position.lat))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.markers[0].position.lng))])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_vm._v("Facilities")]), _vm._v(" "), _c('li', [_vm._v("Facility Record")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header ui-sortable-handle",
    staticStyle: {
      "cursor": "move"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("\n              Facility Record\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('small', {
    staticClass: "label pull-right bg-red"
  }, [_vm._v("NIVI")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Public")]), _vm._v(" "), _c('td', [_vm._v("N/A")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Youth Friendly")]), _vm._v(" "), _c('td', [_vm._v("N/A")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Network")]), _vm._v(" "), _c('td', [_vm._v("N/A")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header ui-sortable-handle",
    staticStyle: {
      "cursor": "move"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("\n              Facility\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "icon fa fa-warning"
  }), _vm._v(" Alert!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("County")]), _vm._v(" "), _c('td', [_vm._v("SubCounty")]), _vm._v(" "), _c('td', [_vm._v("Ward")]), _vm._v(" "), _c('td', [_vm._v("Latitude")]), _vm._v(" "), _c('td', [_vm._v("Longitude")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4c47d960","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/facilities/FacilityRecord.vue
// module id = bq2B
// module chunks = 1